import DateToggle from '../date-toggle'
import slugify from '../../slugify'

export default [
  { name: 'Title', prop: 'title', type: 'text' },
  { name: 'Meta Title', prop: 'meta_title', type: 'text' },
  { name: 'Meta Keywords', prop: 'meta_keywords', type: 'text' },
  { name: 'Meta Description', prop: 'meta_description', type: 'text' },
  { name: 'Meta Image', prop: 'meta_image', type: 'text' },
  { name: 'URL', prop: 'slug', type: 'text', filter: slugify },
  { name: 'Published', prop: 'published_at', type: 'component', component: DateToggle },
  { name: 'Members Only', prop: 'requires_membership', type: 'checkbox' }
]
